import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'id',
  'year',
  'month',
  'day',
  'country',
  'state',
  'tsunamiEventId',
  'locationName',
  'latitude',
  'longitude',
  'scanPreview',
  'plotPreview',
  'scan',
  'netcdf',
  'csv',
  'reference',
]);

export const sort = fromJS([
  { id: 'year', asc: true },
  { id: 'month', asc: true },
  { id: 'day', asc: true },
  { id: 'country', asc: true },
  { id: 'state', asc: true },
  { id: 'locationName', asc: true },
]);

export const minColumns = fromJS([]);
